import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from "@angular/core";

/**
 * This component allows to expand or collapse its content if the content is overflowing.
 *
 * @param lineClamp number, optional (default: 1)
 * @param positionButtonsAbsolute boolean, optional (default: false)
 */
@Component({
  selector: "expandable-content",
  templateUrl: "expandable-content.component.html",
  styleUrls: ["expandable-content.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    tabindex: "0",
  },
})
export class ExpandableContentComponent implements AfterViewInit {
  /** specifies at the end of which line/row the content will be cut at (default: 1) */
  @Input() public lineClamp = 1;
  /** specifies if the button height should be excluded from the component height via position: absolute style rule (default: false) */
  @Input() public positionButtonsAbsolute = false;
  @ViewChild("content", { static: false }) public content: ElementRef<HTMLDivElement>;

  public isOverflowing = false;
  public isExpanded = false;

  constructor(private cdr: ChangeDetectorRef) {}

  public ngAfterViewInit(): void {
    const { scrollHeight, clientHeight } = this.content.nativeElement;
    this.isOverflowing = scrollHeight > clientHeight;
    this.cdr.detectChanges();
  }

  public toggleContent(): void {
    this.isExpanded = !this.isExpanded;
  }
}
